export default "__VITE_ASSET__5gv7Zfyj__"